import { ThunkAction } from '../../../../../../../../types/actions';
import { TCardId } from '../../../../../../../../types/types';
import { getIsLinkCardActive } from '../../../../../../../../store/router/selectors/getIsLinkCardActive';
import { root } from '../../../../../../../../store/constants';
import { getLinkCardBoardId } from '../../../../../../../../store/router/selectors/getLinkCardBoardId';
import { getBoardIdByCardId } from '../../../../../../../../store/model/selectors/getBoardIdByCardId';

export const resetActiveComment = (
    cardId: TCardId
): ThunkAction => {
    return (
        dispatch,
        getState
    ) => {
        const state = getState();
        const isLinkCard = getIsLinkCardActive(state);
        const boardId = isLinkCard ? getLinkCardBoardId(state.router) : getBoardIdByCardId(state, cardId);
        const url = isLinkCard ? root.App.router.getLinkCardUrl(boardId, cardId)
            : root.App.router.getBoardUrl(boardId, 'c-'+ cardId);
        root.App.router.navigate(url);
    }
}
